import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import "../Home/Home.css";
import mission from "../../assets/Images/landing/mission-img.webp";
import vision from "../../assets/Images/landing/vision-img.webp";
import value from "../../assets/Images/landing/value-img.webp";
import ibmaster from "../../assets/Images/landing/ib-master.webp";
import economic from "../../assets/Images/landing/economic.webp";
import PAMM from "../../assets/Images/landing/PAMM.webp";
import Fundamental from "../../assets/Images/landing/Fundamental.webp";
import Social_trade from "../../assets/Images/landing/Social-trade.webp";
import client1 from "../../assets/Images/landing/client1.webp";
import client2 from "../../assets/Images/landing/client2.webp";
import client3 from "../../assets/Images/landing/client3.webp";
import client4 from "../../assets/Images/landing/client4.webp";
import openacc1 from "../../assets/Images/landing/open-acc1.webp";
import openacc2 from "../../assets/Images/landing/open-acc2.webp";
import openacc3 from "../../assets/Images/landing/open-acc3.webp";
import openacc4 from "../../assets/Images/landing/open-acc4.webp";
import playstore from "../../assets/Images/landing/play-store.svg";
import istore from "../../assets/Images/landing/istore.svg";
import qr from "../../assets/Images/landing/qr-scan.svg";
import values from "../../assets/Images/landing/values-img.webp";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import Footer from "../Footer/Footer";
import Header from "../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import { useScroll, useTransform, motion, useInView } from "framer-motion";
import imgcrn from "../../assets/Images/Outterpage/img-crn.webp";

const testimonials = [
  {
    name: "Siddharth",
    position: "CEO",
    text: " As someone new to forex trading, I was overwhelmed by the complexity of the market. Finowiz made it simple and approachable. Their platform is user-friendly, their educational resources are top-notch, and their support team is always there to guide me. I finally feel confident trading!",
    img: `${client1}`,
  },
  {
    name: "Aisyah",
    position: "Product Manager",
    text: "What impressed me most about Finowiz is their deep understanding of market behavior and risk management. Their analysis tools and real-time data help me stay ahead of the curve. Whether you're trading manually or using EAs, Finowiz gives you the edge.",
    img: `${client2}`,
  },
    {
    name: "Rayan",
    position: "Product Manager",
    text: "I’ve traded with multiple forex platforms over the years, but Finowiz stands out for its transparency, lightning-fast execution, and tight spreads. The level of professionalism and trust I’ve experienced here is unmatched. It’s where serious traders belong.",
    img: `${client3}`,
  },
    {
    name: "Irfan",
    position: "Product Manager",
    text: "I’ve been trading with Finowiz for over two years now, and I can honestly say they’ve helped me grow not just as a trader, but as a disciplined investor. Their support, integrity, and commitment to trader success are truly world-class.",
    img: `${client4}`,
  },

];

const options = {
  margin: 50,
  items: 1,
  autoplay: true,
  autoplayTimeout: 6000,
  dots: false, // Hide default dots
  loop: true,
  smartSpeed: 800,
  nav: true, // We will use custom navigation
  responsive: {
    0: {
      dots: true,
      nav: false,
    },
    768: {
      dots: false,
      nav: true,
    },
  },
};

const marketData = [
  { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
  { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
  { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
  { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
  { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];

const Home = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const lg1200 = useMediaQuery(theme.breakpoints.up("1200"));
  const keyMap = { a: "cd1", b: "cd2", c: "cd3", d: "cd4" };

  // Create separate refs
  const refA = useRef(null);
  const refB = useRef(null);
  const refC = useRef(null);
  const refD = useRef(null);

  // Use useInView for each
  const isInViewA = useInView(refA, { once: false });
  const isInViewB = useInView(refB, { once: false });
  const isInViewC = useInView(refC, { once: false });
  const isInViewD = useInView(refD, { once: false });

  return (
    <div className="homepage">
      <Header />
      <section className="banner">
        <div className="contain-width">
          <Grid container sx={{ alignItems: "flexStart" }}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <div
                className="banner-left"
                // style={{ height: xl ? "500px" : "auto" }}
              >
                <p>Trusted Gateway to Smart Trading</p>
                <h1 className="mb-30">Secure, Transparent &<br/>
                  <span> High-Performance  </span> <br/>trading solutions.
                </h1>
                <p className="ban-rgh">
                  Experience low spreads, advanced trading tools, and real-time
                  insights — all with Finowiz.
                </p>
                <div
                  className="btn flex-wrap text-center"
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="#" className="bg-btn">
                    Get Started
                  </Link>
                </div>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Grid container sx={{ alignItems: "center", rowGap: "75px" }}>
                <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                  <div className="banner-right ">
                    <h3>
                      $100B<span class="orange">+</span>
                    </h3>
                    <h5>Trading Volume</h5>
                    <div className="brd-lin-bottom"></div>
                  </div>
                </Grid>
                <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                  <div className="banner-right brd-after">
                    <h3>
                      98<span class="orange">%</span>
                    </h3>
                    <h5>Customer Satisfaction</h5>
                    <div className="brd-lin-bottom"></div>
                  </div>
                </Grid>
                <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                  <div className="banner-right brd-after">
                    <h3>
                      <span class="orange">24/7</span>
                    </h3>
                    <h5>Support Reach</h5>
                    <div className="brd-lin-bottom"></div>
                  </div>
                </Grid>
                <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                  <div className="banner-right brd-after">
                    <h3>
                      200<span class="orange">+</span>
                    </h3>
                    <h5>Markets Available</h5>
                    <div className="brd-lin-bottom"></div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>

      <section className="trade-open">
        <div className="contain-width">
          <div className="left-side display-2">
            <h3>
              Rooted in <span> Purpose, </span> Fuelling the Future
            </h3>
            {/* <p>
                You deserve a platform that empowers you with clarity, speed,
                and reliability. That’s why we’ve created an experience focused
                on simplicity, support, and success. Whether you're a beginner
                or a pro, we’re here to make every trade smarter. Because
                trading should work for you — not against you.
              </p> */}
            <div>
              <Link to="#" className="bg-btn">
                Register now
              </Link>
            </div>
          </div>
          <Grid container spacing={8} sx={{ rowGap: 0 }}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
              className="right-side"
            >
              <div class="card">
                <img src={mission} className="img-fluid" />
                <div class="card-content">
                  <h3>
                    <span>Mission</span>
                  </h3>
                  <p>
                    To empower traders with innovative, transparent, and
                    efficient forex trading solutions, providing comprehensive
                    training and unmatched customer support, while fostering
                    financial growth through cutting-edge technology.
                  </p>
                </div>
              </div>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
              className="right-side"
            >
              <div class="card">
                <img src={vision} className="img-fluid" />
                <div class="card-content">
                  <h3>
                    <span>Vision</span>
                  </h3>
                  <p>
                    To be the leading global forex brokerage, recognized for
                    trust, innovation, market expertise, and educational
                    excellence, shaping the future of financial trading with
                    integrity and empowering traders through continuous
                    learning.
                  </p>
                </div>
              </div>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
              className="right-side"
            >
              <div class="card">
                <img src={value} className="img-fluid" />
                <div class="card-content">
                  <h3>
                    <span>Values</span>
                  </h3>
                  <p>
                    Our core values emphasize integrity, innovation, and
                    education, fostering transparency and trust. With a
                    customer-focused approach, we deliver cutting-edge solutions
                    to meet the evolving needs of the global financial market.
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      <section class="cta-sec">
        <div className="contain-width">
          <Grid container spacing={8}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
              className="left-side"
            >
              <h2>Global Markets</h2>
              <p>
                Unveil numerous possibilities on the most sought-after financial
                instruments worldwide and receive complimentary real-time quotes
                to explore limitless trading prospects.
              </p>
              <Link to="#" class="brd-btn">
                Trade Now
              </Link>
            </Grid>
          </Grid>
        </div>
      </section>

      <section className="trade-easy">
        <div className="contain-width">
          <div className="heading">
            <p>
              <span>Trading Tools</span>
            </p>
            <h2>
              The <span>Tools</span> We Offer
            </h2>
            <p>
              At Finowiz, we provide a comprehensive suite of trading tools to
              help you make informed decisions and optimize your trading
              strategy.
            </p>
          </div>
          <Grid
            container
            sx={{
              maxWidth: "1050px",
              margin: "0 auto",
              padding: { xs: "15px 0", md: "50px 0" },
            }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 5, xl: 5 }}>
              <div className="trade-tools left-side">
                <img src={ibmaster} className="img-fluid" />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7, xl: 7 }}>
              <h3>IB & Master IB</h3>
              <p>
                Join our IB and Master IB programs to earn by referring traders.
                Enjoy tiered commissions, real-time tracking, and dedicated
                support. Whether you're just starting or expanding your network,
                our program grows with you. Start earning more today!
              </p>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              maxWidth: "1050px",
              margin: "0 auto",
              padding: { xs: "15px 0", md: "50px 0" },
              flexDirection: {
                xs: "column-reverse",
                md: "row",
                sm: "row",
              },
            }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7, xl: 7 }}>
              <h3>Economic Calendar</h3>
              <p>
                Stay ahead with our real-time Economic Calendar, featuring key
                global events and data releases. Plan your trades with
                confidence using accurate, up-to-date market insights.
              </p>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 5, xl: 5 }}>
              <div className="trade-tools right-side">
                <img src={economic} className="img-fluid" />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              maxWidth: "1050px",
              margin: "0 auto",
              padding: { xs: "15px 0", md: "50px 0" },
            }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }}>
              <div className="trade-tools left-side">
                <img src={PAMM} className="img-fluid" />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 8, xl: 8 }}>
              <h3>PAMM</h3>
              <p>
                PAMM (Percentage Allocation Management Module) at Finowiz offers
                a unique opportunity for investors to grow their capital by
                pooling funds with professional traders.
              </p>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              maxWidth: "1050px",
              margin: "0 auto",
              padding: { xs: "15px 0", md: "50px 0" },
              flexDirection: { xs: "column-reverse", md: "row", sm: "row" },
            }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 8, xl: 8 }}>
              <h3>Trading Fundamentals</h3>
              <p>
                Trading Fundamentals at Finowiz are designed to provide you with
                a strong foundation in the financial markets. Our platform
                offers educational resources to help you understand key concepts
                such as market analysis, risk management, and trading strategies
              </p>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }}>
              <div className="trade-tools right-side">
                <img src={Fundamental} className="img-fluid" />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              maxWidth: "1050px",
              margin: "0 auto",
            }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3, xl: 3 }}>
              <div className="trade-tools left-side">
                <img src={Social_trade} className="img-fluid" />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 9, xl: 9 }}>
              <h3>Social Trading</h3>
              <p>
                Social Trading at Finowiz allows you to follow and copy the
                strategies of successful traders in real-time. By connecting
                with a community of skilled traders, you can gain insights,
                learn new techniques, and potentially increase your profits.
              </p>
            </Grid>
          </Grid>
        </div>
      </section>

      <section class="cta-sec2">
        <div className="contain-width">
          <Grid container spacing={8}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <label>Lesser The Risk. More The Reward.</label>
              <h2>Learn the Markets. Without Risk.</h2>
              <p>
                Start trading with confidence — no real money required. Sharpen
                your strategies, build your skills, and gain experience in a
                real-market environment without the pressure.
              </p>
              <Link to="#" class="brd-btn">
                Create Demo account
              </Link>
            </Grid>
          </Grid>
        </div>
      </section>

      <section className="success-story">
        <div className="contain-width">
          <h2>
            What our <span>clients </span>
            say about us
          </h2>
          <p>
            Master the Art of Trading with Our Comprehensive Learning Resources.
          </p>

          <OwlCarousel className="owl-theme owl-carousel" {...options}>
            {testimonials.map((testimonial, index) => (
              <div className="item" key={index}>
                <Grid item xs={12}>
                  <div className="testimonial">
                    <div className="testimonial-container gradient-border">
                      <div className="testimonial-content ">
                        <div>
                          <h2>{testimonial.name}</h2>
                          {/* <p className="position">{testimonial.position}</p> */}
                        </div>
                        {/* <div className="ceo-img">
                          <img src={ceo} alt="CEO" />
                        </div> */}
                        <div>
                          <div className="quote-bg">
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M2.57812 15.0293V25.3125L7.70874 20.1777L12.8394 15.043V9.89454V4.74609H7.70874H2.57812V15.0293ZM17.1606 15.0293V25.3125L22.2913 20.1777L27.4219 15.043V9.89454V4.74609H22.2913H17.1606V15.0293Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <p className="quote-text">{testimonial.text}</p>
                        </div>
                      </div>
                      <div className="client-img">
                        <img src={testimonial.img} alt="client1" />
                      </div>
                    </div>
                  </div>
                </Grid>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </section>

      {/* <section className="trade-easy start-trade">
        <div className="contain-width">
          <div className="heading">
            <p>
              <span>How it’s Work</span>
            </p>
            <h2>
              Start <span>Trading</span> on Your Terms
            </h2>
          </div>
          <Grid
            container
            spacing={1}
            sx={{
              maxWidth: "1000px",
              margin: "0 auto",
              padding: { xs: "0 0", md: "50px 0" },
            }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <div class="step-card">
                <div class="icon">
                  <img src={openacc1} alt="open-account" />
                </div>
                <div class="text-content">
                  <div class="step-number">
                    <span class="light">0</span>
                    <span class="highlight1">1</span>
                  </div>
                  <h3 class="title">Open Account</h3>
                  <p class="description">
                    Start your trading journey by creating an account on
                    Finowiz. It's quick and easy — just fill out the necessary
                    details and verify your identity to get started.
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <div class="step-card">
                <div class="icon">
                  <img src={openacc2} alt="open-account" />
                </div>
                <div class="text-content">
                  <div class="step-number">
                    <span class="light">0</span>
                    <span class="highlight2">2</span>
                  </div>
                  <h3 class="title">Choose Account Type</h3>
                  <p class="description">
                    Select an account type that best fits your trading goals,
                    whether you’re just starting or looking for more advanced
                    features. We offer options to meet every trader’s needs.
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }}>
              <div class="step-card" style={{ flexDirection: "column" }}>
                <div class="icon">
                  <img src={openacc3} alt="open-account" />
                </div>
                <div class="text-content">
                  <div class="step-number">
                    <span class="light">0</span>
                    <span class="highlight3">3</span>
                  </div>
                  <h3 class="title">Select a Currency Pair</h3>
                  <p class="description">
                    Choose from a broad selection of currency pairs to trade,
                    all with competitive spreads and various market conditions,
                    allowing you to tailor your strategy.
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 8, xl: 8 }}>
              <div class="step-card">
                <div class="icon">
                  <img src={openacc4} alt="open-account" />
                </div>
                <div class="text-content">
                  <div class="step-number">
                    <span class="light">0</span>
                    <span class="highlight4">4</span>
                  </div>
                  <h3 class="title">Start Trading with Confidence</h3>
                  <p class="description">
                    Begin placing trades and refine your approach with the help
                    of Finowiz’s comprehensive tools and real-time market data,
                    empowering you to trade confidently and effectively.
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section> */}

      <section className="trade-easy sec-3 roadmap-bg ">
        <div className="contain-width">
          <div className="heading">
            <p>
              {" "}
              <span>How it’s Work</span>
            </p>
            <h2>
              Start <span> Trading </span> on Your Terms
            </h2>
            {/* <p>
              Figma ipsum component variant main layer. Prototype share asset
              stroke distribute star create. Rectangle stroke auto figjam
              project library select.{" "}
            </p> */}
          </div>
          <Grid
            container
            spacing={5}
            className="cp-tade-roadmap"
            sx={{ justifyContent: "space-between" }}
          >
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}></Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }} className="">
              <motion.div
                ref={refA}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: isInViewA ? 1 : 0, y: isInViewA ? 0 : 50 }}
                transition={{ duration: 0.5 }}
              >
                {/* <div style={{ height: "100px", backgroundColor: "red" }}>
                                              This fades in when visible and out when not!
                                          </div> */}
                <span className="crn-alg1">
                  {lg1200 && (
                    <span className="crn-box1">
                      <img width="90%" src={imgcrn} />
                    </span>
                  )}
                  <div
                    className="txt-content1"
                    style={{ padding: "20px 30px" }}
                  >
                    <p>Step 1</p>
                    <h4>
                      <span className="grd">Open Account</span>
                    </h4>
                    <p>
                      Start your trading journey by creating an account on
                      Finowiz. It's quick and easy — just fill out the necessary
                      details and verify your identity to get started.
                    </p>
                  </div>
                </span>
              </motion.div>
            </Grid>

            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
              className=" mt-50 "
            >
              <motion.div
                // ref={ref}
                // style={{
                //     opacity: isInView ? 1 : 0,
                //     transition: 'opacity 1s ease-in-out',
                ref={refB}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: isInViewB ? 1 : 0, y: isInViewB ? 0 : 50 }}
                transition={{ duration: 0.5 }}
              >
                <span className="crn-alg1">
                  {lg1200 && (
                    <span className="crn-box1">
                      <img width="90%" src={imgcrn} />
                    </span>
                  )}
                  <div
                    className="txt-content1"
                    style={{ padding: "20px 30px", textAlign: "center" }}
                  >
                    <p>Step 2</p>
                    <h4>
                      <span className="grd">Choose Account Type</span>
                    </h4>
                    <p>
                      Select an account type that best fits your trading goals,
                      whether you’re just starting or looking for more advanced
                      features. We offer options to meet every trader’s needs.
                    </p>
                  </div>
                </span>
              </motion.div>
            </Grid>
            {lg1200 && (
              <>
                {" "}
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}></Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}></Grid>
              </>
            )}

            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
              className="mt-50"
            >
              <motion.div
                ref={refC}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: isInViewC ? 1 : 0, y: isInViewC ? 0 : 50 }}
                transition={{ duration: 0.5 }}
              >
                <span className="crn-alg1">
                  {lg1200 && (
                    <span className="crn-box1">
                      <img width="90%" src={imgcrn} />
                    </span>
                  )}
                  <div
                    className="txt-content1"
                    style={{ padding: "20px 30px", textAlign: "center" }}
                  >
                    <p>Step 3</p>
                    <h4>
                      <span className="grd">Select a Currency Pair</span>
                    </h4>
                    <p>
                      Choose from a broad selection of currency pairs to trade,
                      all with competitive spreads and various market
                      conditions, allowing you to tailor your strategy.
                    </p>
                  </div>
                </span>
              </motion.div>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
              className=" mt-50"
            >
              <motion.div
                ref={refD}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: isInViewD ? 1 : 0, y: isInViewD ? 0 : 50 }}
                transition={{ duration: 0.5 }}
              >
                <span className="crn-alg1">
                  {lg1200 && (
                    <span className="crn-box1">
                      <img width="90%" src={imgcrn} />
                    </span>
                  )}
                  <div
                    className="txt-content1"
                    style={{ padding: "20px 30px", textAlign: "center" }}
                  >
                    <p>Step 4</p>
                    <h4>
                      <span className="grd">Start Trading with Confidence</span>
                    </h4>
                    <p>
                      Begin placing trades and refine your approach with the
                      help of Finowiz’s comprehensive tools and real-time market
                      data, empowering you to trade confidently and effectively.
                    </p>
                  </div>
                </span>
              </motion.div>
            </Grid>
          </Grid>
        </div>
      </section>

      <section className="cta-sec3">
        <div className="contain-width">
          <Grid container spacing={8} sx={{ rowGap: "40px" }}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
              <h3>
                Step into tomorrow, today. Download the <span>Finowiz MT5</span>{" "}
                Platform
              </h3>
              <p>
                Experience cutting-edge trading technology. Unleash your
                potential with advanced tools designed to empower traders at
                every level and optimize your trading journey effortlessly.
              </p>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
              <div className="top-layer">
                <div className="store-btn display-3">
                  <Link>
                    <div className="gradient-box">
                      <div className="display-3">
                        <img src={playstore} alt="playstore" />
                        <div>
                          <p>Download from</p>
                          <h5>Play store</h5>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link>
                    <div className="gradient-box">
                      <div className="display-3">
                        <img src={istore} alt="istore" />
                        <div>
                          <p>Download from</p>
                          <h5>App Store</h5>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="scan-down">
                  <div className="display-2">
                    <img src={qr} alt="istore" />
                    <div>
                      <p>Scan To download</p>
                      <h5> IOS & Android</h5>
                    </div>
                  </div>
                </div>

                <div className="comming-soon gradient-box">
                  <a href="/">Coming Soon</a>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      {/* <section className="values-slider">
        <div className="slider">
          <div className="slide-track">
            {[...marketData, ...marketData].map((item, idx) => (
              <div className="slide" key={idx}>
                <div
                  className={`values ${item.trend === "up" ? "green" : "red"}`}
                >
                  <div className="display-1">
                    <img src={values} alt="logo" />
                    <div>
                      <h5>{item.pair}</h5>
                      <p>
                        {item.trend === "up" ? (
                          <ArrowDropUpRoundedIcon />
                        ) : (
                          <ArrowDropDownRoundedIcon />
                        )}
                        {item.value}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default Home;
